import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a7ecfc2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1a7ecfc2&prod&lang=css"
import style1 from "../../assets/commoon/css/common.css?vue&type=style&index=1&id=1a7ecfc2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ecfc2",
  null
  
)

export default component.exports